module.exports = __webpack_public_path__ + "img/1594290125.30a45a07.jpg";